import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Dropdown, Panel, PrimaryButton, Stack} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";

function CloneVentureAddon(props) {
    const [user] = useContext(AuthContext);
    const [venture, setVenture] = useState('');
    const [ventureId, setVentureId] = useState(0);

    const _submit = (e) => {
        e.preventDefault();
        fetch(`/api/venture/${props.add.venture_id}/addon/clone/${ventureId.key}`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='CloneVentureAddon'>Importuj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        setVentureId(0);
        async function fetchVentures() {
            await fetch(`/api/venture/${props.add.venture_id}/addon/clone`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setVenture(data.map((item) => {
                        return {key: item.id, text: `${item.name}`};
                    }))
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchVentures();
        return () => abortController.abort();
    }, [props.add, user.token])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Importuj Listę Dodatków"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='CloneVentureAddon'>
                <Dropdown
                    label="Kontrakt"
                    selectedKey={ventureId ? ventureId.key : undefined}
                    onChange={(e, item) => setVentureId(item)}
                    placeholder="Wybierz z listy"
                    options={venture}
                />
            </form>
        </Panel>
    )
}

export default CloneVentureAddon;